export enum PreregLinkInfo {
  Analysis = 'prereg_analysis',
  Designs = 'prereg_designs',
  Both = 'prereg_both',
}
